import React from 'react'

export default function Badge({ value }) {
  if (value === 0) return null
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 12,
        color: 'white',
        position: 'absolute',
        right: 0,
        top: -6,
        background: '#0077CC',
        width: 16,
        height: 16,
        borderRadius: 16,
      }}
    >
      <span>{value < 10 ? `${value}+` : value}</span>
    </div>
  )
}
